import { FC } from "react";
import { store } from "../../store";
import { Provider } from "react-redux";
import axios from "axios";
import { setPointOfSaleWhiteCache } from "./lib/white-cache";
import { PointOfSalesPage } from "./PointOfSalesPage";
import jwtDecode from "jwt-decode";
import { InitData } from "../../util/init-data";

interface PointOfSaleInterface {
  software: "bb" | "fw" | "crm" | "f10";
  root?: string;
  token?: string;
  url?: string;
  isBluBookingActive?: boolean;
  isConsole?: boolean;
  focusWeb?: boolean;
  isFocus10?: boolean;
  isCrm?: boolean;
  isSingleCalendarManagement?: boolean;
}

export const NewPointOfSales: FC<PointOfSaleInterface> = ({
  software,
  root = "",
  token,
  url,
  isBluBookingActive,
  isConsole,
  focusWeb,
  isFocus10,
  isCrm,
  isSingleCalendarManagement,
}): JSX.Element => {
  if (url !== undefined) axios.defaults.baseURL = url;

  if (token !== undefined) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  let isBBActive: boolean = false;
  if (isBluBookingActive !== undefined) {
    isBBActive = isBluBookingActive;
  } else {
    const authHeader = axios.defaults.headers.common.Authorization;
    if (authHeader !== null && authHeader !== undefined) {
      try {
        const decoded: any = jwtDecode(authHeader.toString());
        isBBActive = decoded["IsBluBookingActive"] === "True";
      } catch {
        // token assente o non decodificabile: BluBooking considerato non attivo
      }
    }
  }

  setPointOfSaleWhiteCache({
    isBluBookingActive: isBBActive,
    path: focusWeb ? "/diaryapi" : "/api",
    isFocusWeb: focusWeb ?? software === "fw",
    isFocus10: isFocus10 ?? software === "f10",
    isConsole: isConsole ?? software === "bb",
    isCrm: isCrm ?? software === "crm",
  });

  return (
    <Provider store={store}>
      <InitData
        software={software}
        isSingleCalendarManagement={isSingleCalendarManagement}
        isFocusWeb={focusWeb}
      />
      <PointOfSalesPage root={root} />
    </Provider>
  );
};
